'use client';

// imports
import { useAtom } from 'jotai';

// lib files
import CompanionState from '@/lib/types/atoms/companionState';
import { myListShowsAtom, myListShowsStatus as myListShowsStatusAtom } from '@/lib/atoms/myListShows';
import { useHasMounted } from '@/lib/hooks';
import { userProfile, userProfileStatus } from '@/lib/atoms/profile';

// components
import LinkButton from '@/components/Button/LinkButton';
import LoadingIndicator from '@/components/LoadingIndicator/LoadingIndicator';
import MyListShowPosterGrid from '@/components/MyList/MyListShows/MyListShowPosterGrid';
import SignInButton from '@/components/Navigation/SignInButton';

// styles
import styles from './MyListShows.module.scss';
const MyListShows = () => {
  const [profile] = useAtom(userProfile);
  const [profileStatus] = useAtom(userProfileStatus);
  const [myListShowsData] = useAtom(myListShowsAtom);
  const [myListShowsStatus] = useAtom(myListShowsStatusAtom);
  const isLoading = profileStatus === CompanionState.IsLoading || myListShowsStatus === CompanionState.IsLoading;
  const hasMounted = useHasMounted();
  if (!hasMounted) return null;
  let content = null;
  switch (true) {
    // happy path - user is signed in and has shows in myListShowsData
    case profile && !isLoading && myListShowsData && myListShowsData.length > 0:
      content = <MyListShowPosterGrid shows={myListShowsData} />;
      break;
    case isLoading:
      content = <LoadingIndicator />;
      break;
    // user is signed in but has not favorited any shows
    case profile && !myListShowsData:
    case profile && myListShowsData && myListShowsData.length === 0:
      content = <div className={styles.my_list_shows_user_prompt}>
          <h2>Shows you add to My List will appear here.</h2>
          <LinkButton href="/shows/">
            Browse PBS Shows
          </LinkButton>
        </div>;
      break;
    // user is not signed in
    default:
      content = <div className={styles.my_list_shows_user_prompt}>
          <h2>Sign in to add shows to My List</h2>
          <SignInButton>
            Sign In to Access
          </SignInButton>
        </div>;
      break;
  }
  return <div className={styles.my_list_shows} data-sentry-component="MyListShows" data-sentry-source-file="MyListShows.tsx">
     {content}
    </div>;
};
export default MyListShows;